import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as container from '@/lib/container.js'

import * as user_model from '@/model/user.js'




export function create
(code: string, appid: string): HttpBodyUnpacking<void>
{
	return http.post('/user', { code, appid })

}

export function create_scope
(id: string): HttpBodyUnpacking<void>
{
	return http.post(`/user/${id}/scope`)

}


export function update
(
	id: string,

	data: {
		active?  : boolean
		avatar?  : string
		nickname?: string
		color?   : string
		phone?   : string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/user/${id}`, data)

}


export function retrieve
(id: string): HttpBodyUnpacking<user_model.THydratedDocumentType>
{
	return http.get(`/user/${id}`)


}

export function retrieves
(
	params: container.PagerParams<
		{ scope?: boolean }

	>,

)
:	HttpBodyUnpacking<user_model.THydratedDocumentType[]>
{
	return http.get('/users', { params })

}
